
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.703 14.845H10.7a.354.354 0 01-.252-.106.344.344 0 01-.098-.252l.001-.084v-.047c-.004-1.012-.245-6.064-4.597-6.064a.348.348 0 01-.35-.347c0-.191.156-.346.35-.346 4.353 0 4.593-5.052 4.597-6.064v-.048l-.001-.083a.344.344 0 01.098-.252.367.367 0 01.506 0 .346.346 0 01.1.252l-.002.083v.048c.005 1.012.245 6.064 4.597 6.064.194 0 .351.155.351.346a.348.348 0 01-.35.347c-4.353 0-4.594 5.052-4.598 6.064v.001a.24.24 0 010 .023v.023l.002.084a.344.344 0 01-.099.252.354.354 0 01-.252.105zM2.572 6.575h-.004a.348.348 0 01-.346-.335c0-.01-.002-.05-.001-.117-.007-.344-.08-1.423-.697-2.041-.3-.301-.684-.448-1.173-.448A.348.348 0 010 3.288c0-.192.157-.347.35-.347.496 0 .883-.15 1.185-.458.64-.655.684-1.805.686-2.07V.392.358a.346.346 0 01.211-.33.354.354 0 01.388.075.357.357 0 01.101.241h.002v.127c.009.363.09 1.416.696 2.023.3.3.684.447 1.173.447.194 0 .351.155.351.347a.348.348 0 01-.35.346c-.496 0-.883.15-1.185.458-.642.656-.685 1.809-.686 2.071V6.217a.346.346 0 01-.35.358zM6.038 16h-.006a.348.348 0 01-.344-.335v-.103c-.009-.424-.126-1.153-.532-1.558-.223-.225-.51-.334-.877-.334a.348.348 0 01-.351-.346c0-.191.157-.347.35-.347.372 0 .662-.111.886-.34.544-.556.523-1.62.523-1.631a.346.346 0 01.212-.33.354.354 0 01.388.075.353.353 0 01.101.24h.001v.11c.01.425.13 1.142.53 1.543.224.225.51.333.878.333.194 0 .35.155.35.347a.348.348 0 01-.35.346c-.371 0-.66.112-.885.341-.544.555-.524 1.62-.523 1.631a.346.346 0 01-.35.358z"}})])
          )
        }
      }
    